import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e9083b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Our Celebrities"),
  /*#__PURE__*/_createElementVNode("h2", { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }, "Exclusively shining with us — only on MyCelebrity.")
], -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "team-single-team transition-y" }
const _hoisted_6 = { class: "position-relative z-1" }
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = { class: "team-content" }
const _hoisted_9 = { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-style pb-75" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-md-6",
            key: team.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  title: "We connect brands with celebrities and influencers for powerful digital campaigns.",
                  class: "team-img",
                  src: team.image,
                  alt: "team",
                  onClick: ($event: any) => (_ctx.goToTestimonial(team.id)),
                  style: {"cursor":"pointer"}
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(team.name), 1),
                _createElementVNode("span", null, _toDisplayString(team.designation), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_10
    ])
  ]))
}